import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";

type InitialState = {
  runOutModal: boolean;
}

const initialState: InitialState = {
  runOutModal: false,
}

const modalSlice = createSlice({
  name: 'modals',
  initialState,
  reducers: {
    toogleRunOutModal: (state) => {
      state.runOutModal = !state.runOutModal
    }
  }
});

export const { toogleRunOutModal } = modalSlice.actions;

export const selectRunOutModalStatus = (state: RootState) => state.modal;

export default modalSlice.reducer;
